import {ReactNode} from "react";
import {StyleSheet, View, ViewStyle} from "react-native";

type Props = {
    children: ReactNode,
    style?: ViewStyle,
    vertical?: boolean,
    centered?: boolean,
}

export default function Nav({children, style, vertical, centered}: Props) {
    return (
        <View
            style={[
                styles.container,
                vertical ? styles.vertical : styles.horizontal,
                centered ? styles.centered : {},
                style
            ]}
        >
            {children}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 8,
        width: "100%",
    },
    centered: {
        justifyContent: "center",
        alignItems: "flex-start",
        alignContent: "flex-start"
    },
    vertical: {
        flexDirection: "column",
        justifyContent: "flex-start",
    },
    horizontal: {
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        minHeight: 40,
    }
});